import ManageDependentDashboard from "./subcomponents/Dashboard";

const ManageDependents = () => {
  return (
    <>
      <ManageDependentDashboard/>
    </>
  );
};

export default ManageDependents;
